<template>
  <div class="card">
    <div class="card-body">

      <div class="mb-3">
        <ol>
          <li class="mb-3">
            <p for="massUpload" class="form-label font-weight-bold">
              Unduh template excel
            </p>
            <a class="btn btn-primary text-light" @click="download('upload_massal.xlsx')">
              <i class="fa fa-download"></i>
              Download Template Massal
            </a>
          </li>
          <li class="mb-4">
            <p class="font-weight-bold">Untuk List Kategori Lihat Daftar Di bawah ini.</p>
            <a class="" data-toggle="collapse" href="#kategoriBarang">
              <p>
                <u>List Kategori Barang</u>
              </p>
            </a>
            
              <div class="collapse" id="kategoriBarang">
                <div class="card card-body">
                  <div class="form-group row">
                    <div class="col-lg-3">
                      <select @change="getCategoryVal" name="nonBookCategory" id="nonBookCategory" class="is-invalid form-control">
                        <option v-for="(lc, index) in listCategory" :key="index" :value="lc.id">
                          {{ lc.title }}
                        </option>
                      </select>
                      <div class="invalid-feedback">
                        Pilih Kategori 
                      </div>
                    </div>

                    <p id="loadingCategory1" class="mt-1 d-none small">
                      Loading <i class="fa fa-spinner fa-spin"></i>
                    </p>

                    <div class="col-lg-3">
                      <select @change="getSubCategoryVal"  name="nonBookSubCategory" id="nonBookSubCategory"
                        class="is-invalid form-control d-none">
                        <option v-for="(lsc, index) in listSubCategory" :key="index" :value="lsc.id">
                          {{ lsc.title }}
                        </option>
                      </select>
                      
                    </div>

                    <p id="loadingCategory2" class="mt-1 d-none small">
                      Loading <i class="fa fa-spinner fa-spin"></i>
                    </p>

                    <div class="col-lg-3">
                      <select @change="lastCategoryBarang"  name="nonBookSub2Category" id="nonBookSub2Category" class="form-control d-none is-invalid">
                        <option v-for="(lsc, index) in listSub2Category" :key="index" :value="lsc.id">
                          {{ lsc.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div id="resultBarangCategory"></div>
                </div>
              </div>

            <a class="" data-toggle="collapse" href="#kategoriJasa">
              <p>
                <u>List Kategori Jasa</u>
              </p>
            </a>

            <div class="collapse" id="kategoriJasa">
                <div class="card card-body">
                  <div class="form-group row">
                  <div class="col-lg-3">
                    <select
                      @change="getCategoryValJasa"
                      name="jasaCategory"
                      id="jasaCategory"
                      class="form-control"
                    >
                      <option
                        v-for="(lc, index) in listCategoryJasa"
                        :key="index"
                        :value="lc.id"
                      >
                        {{ lc.title }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <select
                      @change="lastCategoryJasa"
                      name="jasaSubCategory"
                      id="jasaSubCategory"
                      class="form-control"
                    >
                      <option
                        v-for="(lsc, index) in listSubCategoryJasa"
                        :key="index"
                        :value="lsc.id"
                      >
                        {{ lsc.title }}
                      </option>
                    </select>
                  </div>
                </div>
                  <div id="resultJasaCategory"></div>
                </div>
              </div>
          </li>
          <li class="mb-4">
            <p class="font-weight-bold">Untuk List Penerbit / Merek(Brand)</p>
            <div class="col-md-4 mb-3" style="margin-left:-10px">
              <vue-select
                  :options="listPenerbit"
                  v-model="valPenerbit"
                  label="name"
                  placeholder="Pilih Merk / Penerbit.."
                  :clearable="clearable"
                />
            </div>
            <p>Silahkan input ke excel untuk Merk / Penerbit <strong>"{{valPenerbit.name}}"</strong> 
                dengan kode <strong>"{{valPenerbit.manufacturer_id}}"</strong>
                </p>
          </li>
          <li>
            <form enctype=multipart/form-data> <label for="massUpload" class="form-label font-weight-bold">Mass Upload
              (Format.xlsx)</label>
              <input class="form-control" type="file" id="massUpload">
            </form>
            <ul class="bg-soft-warning m-2 pt-2 pb-2">
              <li class="pr-3">Pastikan nama template sama seperti saat diunduh</li>
              <li class="pr-3">Pastikan format dan field sama seperti saat diunduh</li>
              <li class="pr-3">Dalam 1 file maksimal upload 100 produk</li>
              <li class="pr-3">Pastikan URL Gambar yang dimasukkan formatnya adalah <b>.jpeg</b> atau <b>.jpg</b></li>
            </ul>
          </li>
          <li>
            <button type="button" @click="massUpload" class="btn btn-primary">Submit</button>
          </li>
        </ol>

      </div>
      <div class="table-responsive" v-if="isOpen">
        <p class="ml-3"> Hasil Upload Produk Massal</p>
        <span class="text-danger ml-3" v-for="(err,index) in arrayFailed" :key="index">
          {{err}}
        </span>
        <table class="table table-bordered">
          <thead>
            <tr class="table-condensed text-uppercase text-muted text-sm-center">
              <th scope="col">No</th>
              <th v-for="(col,index) in column" :key="index" scope="col">{{col.field}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dr,index) in dataRow" :key="index">
              <td >{{index+1}}</td>
              <td  v-for="(drr,index) in dr" :key="index">
                <span class="text-danger bg-secondary" v-if="drr.error !== ''">{{drr.error}}</span>
                <span class="text-danger" v-if="drr.field === 'Foto Utama'"><img :src="drr.value" height="50px"
                    alt=""></span>
                <span class="text-danger" v-else-if="drr.field === 'Foto 1'"><img :src="drr.value" height="50px"
                    alt=""></span>
                <span class="text-danger" v-else-if="drr.field === 'Foto 2'"><img :src="drr.value" height="50px"
                    alt=""></span>
                <span class="text-danger" v-else-if="drr.field === 'Foto 3'"><img :src="drr.value" height="50px"
                    alt=""></span>
                <span v-else>{{drr.value}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import VueSelect from "vue-select";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      isOpen: false,
      arrayFailed: [],
      countError: 0,
      dataRow: [],
      column: [],
      listSubCategory: Array,
      listSub2Category: Array,
      listCategory: [],
      catVal: 0,
      subCatVal: 0,
      listCategoryJasa: [],
      listSubCategoryJasa: [],
      catValJasa: 0,
      listPenerbit: [],
      clearable: false,
      valPenerbit: "",
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
      countChat: "countChat",
    }),
  },
  async mounted() {
    await this.$nextTick();
    // $(".toggle_table").bootstrapToggle();
    this.getSubCategory();
    this.getBarangCategory();
    this.getJasaCategory();
    this.getSubCategoryJasa();
    this.getPenerbit();
    Vue.component("vue-select", VueSelect);
  },
  watch: {
    catVal() {
      this.getSubCategory();
    },
    subCatVal() {
      this.getSub2Category();
    },
    catValJasa() {
      this.getSubCategoryJasa();
    },
    valPenerbit() {
      this.getPenerbit();
    },
  },
  updated() {
    if (this.listSubCategoryJasa.length === 0) {
      let textSelect = $("#jasaCategory option:selected").text();
      let valSelect = $("#jasaCategory").val();
      $("#resultJasaCategory").html(
        `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
      );
      $("#jasaSubCategory").addClass("d-none");
    } else if (this.listSubCategoryJasa.length === 1) {
      let textSelect = $("#jasaSubCategory option:selected").text();
      let valSelect = $("#jasaSubCategory").val();

      $("#resultJasaCategory").html(
        `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
      );
      $("#jasaSubCategory").removeClass("d-none");
      $("#jasaSubCategory").removeClass("is-invalid");
    } else {
      $("#jasaSubCategory").removeClass("d-none");
      $("#jasaSubCategory").addClass("is-invalid");
      $("#resultJasaCategory").html(
        "<span class='text-danger'>Pilih Kategori</span>"
      );
    }
    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2Category").addClass("d-none");
    } else {
      $("#resultBarangCategory").html(
        "<span class='text-danger'>Pilih Kategori</span>"
      );
    }

    if (this.listSub2Category.length === 1) {
      let textSelect = $("#nonBookSub2Category option:selected").text();
      let valSelect = $("#nonBookSub2Category").val();

      $("#resultBarangCategory").html(
        `${
          valSelect === null
            ? '<span class="text-danger">Pilih Kategori</span>'
            : `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
        }`
      );
      $("#nonBookSub2Category").removeClass("d-none");
      $("#nonBookSub2Category").removeClass("is-invalid");
    }

    // if (this.listSubCategoryJasa.length === 0) {
    //   $("#jasaSubCategory").addClass("d-none");
    // }
  },
  methods: {
    download(fileName) {
      var a = document.createElement("a");
      a.href = this.user.downloadBulkTemplate;
      a.setAttribute("download", fileName);
      a.click();
    },
    getPenerbit() {
      fetch(
        "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/detailproduk/"
      )
        .then((response) => response.json())
        .then((data) => {
          this.listPenerbit = data.listpenerbit;
          // this.listCategory = data.listcat;
        });
    },
    massUpload() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=4el2b57skbt9cql88fgl0u9mgepmipqn");

      var formdata = new FormData();

      formdata.append(
        "file_upload",
        document.getElementById("massUpload").files[0],
        document.getElementById("massUpload").files[0].name
      );
      formdata.append("mall_id", this.user.id);
      //       formdata.append(
      //   "file",
      //   document.getElementById("massUpload").files[0],
      //   document.getElementById("massUpload").files[0].name
      // );
      // formdata.append("mall_id", this.user.id);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let timerInterval = timerInterval;
      this.$swal.fire({
        title: "<span style='font-size:17px'>Sedang diproses</span>",
        html: "Mohon Tunggu...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 350,
        didOpen: () => {
          this.$swal.showLoading();
          timerInterval = setInterval(() => {
            const content = this.$swal.getContent();
            if (content) {
              const b = content.querySelector("b");
              if (b) {
                b.textContent = this.$swal.getTimerLeft();
              }
            }
          }, 100);
        },
      });
      // https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/addprodukmass
      fetch(
        "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/addprodukmass",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          this.$swal.close();
          this.isOpen = true;
          this.arrayFailed = data.arrayFailed;
          this.countError = data.countError;
          this.dataRow = data.dataRow;
          this.column = data.dataRow[0];
        })
        .catch((error) => console.log("error", error));
    },
    filterCatNonBook(listCat) {
      return listCat.id != 22 && listCat.id != 23;
    },
    getBarangCategory() {
      axios
        .get("https://siplah.eurekabookhouse.co.id/api/product/category?for=seller")
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          this.listCategory = catList.filter(this.filterCatNonBook);
          // this.listCategory = data.data.data[0].submenu.menu;
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
        });
    },
    getCategoryVal() {
      $("#nonBookSubCategory").addClass("is-invalid");
      $("#nonBookSub2Category").addClass("d-none");
      $("#loadingCategory1").removeClass("d-none");
      var index = $("#nonBookCategory").prop("selectedIndex");
      if (index > 2) {
        this.catVal = index + 2;
      } else {
        this.catVal = index;
      }
      this.subCatVal = 0;
      $("#nonBookCategory").removeClass("is-invalid");
      $("#resultBarangCategory").html(
        `<span class="text-danger">Pilih Kategori</span>`
      );
      if ($("#nonBookSubCategory").hasClass("is-invalid")) {
        $("#resultBarangCategory").html(
          `<span class="text-danger">Pilih Kategori</span>`
        );
      }
    },
    getSubCategory() {
      this.subCatVal = 0;
      axios
        .get("https://siplah.eurekabookhouse.co.id/api/product/category?for=seller")
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
          $("#loadingCategory1").addClass("d-none");
          $("#nonBookSubCategory").removeClass("d-none");
        });
    },
    getSubCategoryVal() {
      let textSelect = $("#nonBookSubCategory option:selected").text();
      let valSelect = $("#nonBookSubCategory").val();
      $("#loadingCategory2").removeClass("d-none");
      $("#nonBookSub2Category").addClass("d-none");
      var index = $("#nonBookSubCategory").prop("selectedIndex");
      this.subCatVal = index;
      $("#nonBookSubCategory").removeClass("is-invalid");
      $("#nonBookSub2Category").addClass("is-invalid");
      $("#resultBarangCategory").html(
        `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
      );
    },
    getSub2Category() {
      axios
        .get("https://siplah.eurekabookhouse.co.id/api/product/category?for=seller")
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSub2Category =
            data.data.data[0].submenu.menu[this.catVal].submenu[
              this.subCatVal
            ].submenu;
          $("#loadingCategory2").addClass("d-none");
          $("#nonBookSub2Category").removeClass("d-none");
        });
    },
    lastCategoryBarang() {
      let textSelect = $("#nonBookSub2Category option:selected").text();
      let valSelect = $("#nonBookSub2Category").val();
      $("#nonBookSub2Category").removeClass("is-invalid");
      $("#resultBarangCategory").html(
        `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
      );
    },
    // di bawah ini buat list kategori jasa
    getJasaCategory() {
      axios
        .get("https://siplah.eurekabookhouse.co.id/api/product/category?for=seller")
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listCategoryJasa = data.data.data[1].submenu.menu;
          this.listSubCategoryJasa =
            data.data.data[1].submenu.menu[this.catValJasa].submenu;
        });
    },
    getCategoryValJasa() {
      var e = $("#jasaCategory").prop("selectedIndex");
      this.catValJasa = e;
      $("#jasaSubCategory").addClass("is-invalid");
    },
    getSubCategoryJasa() {
      axios
        .get("https://siplah.eurekabookhouse.co.id/api/product/category?for=seller")
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategoryJasa =
            data.data.data[1].submenu.menu[this.catValJasa].submenu;
        });
    },
    lastCategoryJasa() {
      let textSelect = $("#jasaSubCategory option:selected").text();
      let valSelect = $("#jasaSubCategory").val();
      $("#resultJasaCategory").html(
        `Silahkan input ke excel untuk kategori ${textSelect} dengan kode <b>"${valSelect}"</b>`
      );
      $("#jasaSubCategory").removeClass("is-invalid");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "vue-select/src/scss/vue-select.scss";
</style>
<style scoped>
.bg-secondary {
  background: #c7c7c7 !important;
}
input[type="file"i] {
  appearance: none;
  background-color: initial;
  cursor: default;
  align-items: baseline;
  color: inherit;
  text-overflow: ellipsis;
  white-space: pre;
  text-align: start !important;
  padding: initial;
  border: initial;
  overflow: hidden !important;
}

.input {
  /* -webkit-writing-mode: horizontal-tb !important; */
  text-rendering: auto;
  color: -internal-light-dark(black, white);
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  appearance: auto;
  background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
  -webkit-rtl-ordering: logical;
  cursor: text;
  margin: 0em;
  font: 400 13.3333px Arial;
  padding: 1px 2px;
  border-width: 2px;
  border-style: inset;
  border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
  border-image: initial;
}
</style>